import React from 'react';


import {Container,Col, Row,Nav} from 'react-bootstrap';
import {Helmet} from "react-helmet";

function errorPage (props) {

	console.log("Inside Page Not Found");
   return (
	
       

      <Container>
<Helmet>
                <meta charSet="utf-8" />
					<title>404 File Not Found Error</title>
					<meta name="description" content="404 | File not Found Error"  />
					
                <link rel="canonical" href="https://shopmuthu.com/404" />
            </Helmet>
        
    <Row >
		<Col >
			<Nav>
				<ol className="breadcrumb">
					<li className="breadcrumb-item">
						<a href="/">Home</a>
					</li>			
					
				</ol>
			</Nav>
		</Col>
	</Row>
  


  <div className="row">
		<div className="col-md-12">		
				
				<h1>Page Not Found</h1>
				<p>Sorry, there is nothing to see here.</p>
				<p>Check <button className="btn btn-success" ><a href="/" styles="color:black!">Home Page</a></button> for products</p>
			
			
		</div>
	</div>  


</Container>              
            
      
        
        )
	}

export default errorPage;